"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useBroadcastParams = require("../../hooks/useBroadcastParams");
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _PermissionTooltip = _interopRequireDefault(require("../Permissions/PermissionTooltip"));
var _PermissionController = require("../Permissions/PermissionController");
var _RoleNames = require("../../constants/RoleNames");
var _globalTooltipDelay = require("../../utils/globalTooltipDelay");
var _TooltipMessages = require("./TooltipMessages");
var _SourceListItemCtaIcons = require("./SourceListItemCtaIcons.styled");
var _useTranslate2 = require("../../locales/useTranslate");
var _this = void 0; // permissions
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.TOGGLE_MUTE];
};
var SourceListItemCtaIcons = function SourceListItemCtaIcons(props) {
  var featured = props.featured,
    muted = props.muted,
    loop = props.loop,
    onFeaturedToggleClicked = props.onFeaturedToggleClicked,
    onMuteToggleClicked = props.onMuteToggleClicked,
    sourceType = props.sourceType,
    onLoopToggleClicked = props.onLoopToggleClicked,
    sourceId = props.sourceId,
    onCameraToggleClicked = props.onCameraToggleClicked,
    isCameraOn = props.isCameraOn,
    isMaximumCameraSourcesOn = props.isMaximumCameraSourcesOn,
    onSourceSetToLive = props.onSourceSetToLive,
    hovered = props.hovered,
    isStagedSourcesActive = props.isStagedSourcesActive,
    isTooltipVisible = props.isTooltipVisible,
    toggleTooltipVisibilityOn = props.toggleTooltipVisibilityOn,
    user = props.user,
    viewPermissions = props.viewPermissions,
    source = props.source,
    layout = props.layout,
    live = props.live;
  var eventId = (0, _useBroadcastParams.useBroadcastParams)();
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var presenterTitle = translate('PresenterTitle_Mic_Popover');
  var MIC_ON = "".concat(presenterTitle, " ").concat(translate('Mic_On_Popover'));
  var MIC_OFF = "".concat(presenterTitle, " ").concat(translate('Mic_Off_Popover'));
  var CAMERA_ON = "".concat(presenterTitle, " ").concat(translate('Camera_On_Popover'));
  var CAMERA_OFF = "".concat(presenterTitle, " ").concat(translate('Camera_Off_Popover'));
  if (source.cameraUnavailable) {
    CAMERA_OFF = source.user === user._id ? "".concat(translate('Camera_Permission_Popover')) : "".concat(translate('Camera_Unavailable_Popover'));
  }
  if (sourceType === _.MEDIA) return null;
  var throttlePropagation = function throttlePropagation(event) {
    event.stopPropagation();
  };
  var displayPermissionTooltip = function displayPermissionTooltip(enableFeature, targetElementId, canToggleCamera) {
    return _react["default"].createElement(_PermissionTooltip["default"], {
      displayTooltip: !enableFeature && !canToggleCamera,
      targetElementId: targetElementId,
      requiredRole: "Admin or show caller"
    });
  };
  var displayVideoMediaControls = function displayVideoMediaControls(enableFeature) {
    var targetElementId = 'video-media-controls';
    var loopIconId = "loop-icon-".concat(sourceId);
    var volumeIconId = "volume-icon-".concat(sourceId);
    var volumeTooltipMessage = muted ? translate((0, _TooltipMessages.getVolumeOffMessage)()) : translate((0, _TooltipMessages.getVolumeOnMessage)());
    return _react["default"].createElement(_SourceListItemCtaIcons.IconContainer, {
      id: targetElementId,
      $isHovered: hovered,
      onMouseLeave: toggleTooltipVisibilityOn
    }, hovered && _react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: loopIconId
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledTransparentIcon, {
      active: loop,
      activeIcon: _freeSolidSvgIcons.faRepeat,
      inactiveIcon: _freeSolidSvgIcons.faRepeat,
      iconColor: !loop ? '#fff' : '#33373d',
      enableFeature: enableFeature,
      screenReaderText: "Loop Media Source",
      onClick: enableFeature ? onLoopToggleClicked : function () {},
      ddActionName: "Loop ".concat(sourceType, " source - ").concat(sourceId)
    }), enableFeature && isTooltipVisible && _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: loopIconId,
      message: translate((0, _TooltipMessages.getLoopMessage)())
    })), _react["default"].createElement("div", {
      id: volumeIconId
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledSolidIcon, {
      activeIcon: _freeSolidSvgIcons.faVolumeUp,
      inactiveIcon: _freeSolidSvgIcons.faVolumeMute,
      active: !muted,
      enableFeature: enableFeature,
      iconColor: muted ? '#de2f1b' : '#33373d',
      screenReaderText: "Mute Media Source",
      "data-testid": "mute-media-source-".concat(sourceId),
      ddActionName: "".concat(muted ? 'Unmute' : 'Mute', " ").concat(sourceType, " source - ").concat(sourceId),
      onClick: enableFeature ? onMuteToggleClicked : function () {}
    }), enableFeature && isTooltipVisible && _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: volumeIconId,
      message: volumeTooltipMessage
    })), displayPermissionTooltip(enableFeature, targetElementId));
  };
  var displayMuteComponent = function displayMuteComponent(enableFeature) {
    var targetElementId = "mute-toggle-".concat(sourceId);
    var muteIconClickHandler = enableFeature ? onMuteToggleClicked : throttlePropagation;
    var toolTipMessage = muted ? MIC_OFF : MIC_ON;
    return _react["default"].createElement(_SourceListItemCtaIcons.StyledPermissionWrapper, {
      id: targetElementId,
      "data-testid": muted ? 'microphone-button-unmute' : 'microphone-button-mute',
      enableFeature: enableFeature,
      onMouseLeave: toggleTooltipVisibilityOn
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledSolidIcon, {
      active: !muted,
      activeIcon: _freeSolidSvgIcons.faMicrophoneAlt,
      onClick: muteIconClickHandler,
      enableFeature: enableFeature,
      screenReaderText: "Mute Source",
      inactiveIcon: _freeSolidSvgIcons.faMicrophoneAltSlash,
      iconColor: muted ? '#de2f1b' : '#33373d',
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      "aria-pressed": !muted,
      ddActionName: "".concat(muted ? 'Unmute' : 'Mute', " ").concat(sourceType, " source - ").concat(sourceId)
    }), enableFeature && isTooltipVisible && _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: toolTipMessage
    }), displayPermissionTooltip(enableFeature, targetElementId));
  };
  var displayFeaturedIcon = function displayFeaturedIcon(enableFeature) {
    var targetElementId = "featured-toggle-".concat(sourceId);
    var featuredClickHandler = enableFeature ? onFeaturedToggleClicked : throttlePropagation;
    return _react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledTransparentIcon, {
      screenReaderText: "Feature presenter",
      active: featured,
      onClick: featuredClickHandler,
      activeIcon: _freeSolidSvgIcons.faThumbTack,
      inactiveIcon: _proSolidSvgIcons.faThumbTack,
      enableFeature: enableFeature,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      ddActionName: "Feature presenter - ".concat(sourceId)
    }), enableFeature && isTooltipVisible ? _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: translate((0, _TooltipMessages.getFeaturedSourceText)())
    }) : displayPermissionTooltip(enableFeature, targetElementId));
  };
  var displayVideoToggleComponent = function displayVideoToggleComponent(enableFeature) {
    var targetElementId = "camera-toggle-".concat(sourceId);
    var toolTipMessage = isCameraOn ? CAMERA_ON : CAMERA_OFF;
    var userRole = (0, _PermissionController.extractUserRole)(user, eventId);
    var canToggleCamera = (userRole && userRole.toLowerCase()) !== _RoleNames.ROLE_NAME_CONTRIBUTOR.toLowerCase();
    var videoClickHandler = isMaximumCameraSourcesOn && !isCameraOn || !canToggleCamera ? throttlePropagation : onCameraToggleClicked;
    if (!enableFeature || source.cameraUnavailable) {
      videoClickHandler = throttlePropagation;
    }
    return _react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledVideoIcon, {
      active: isCameraOn,
      activeIcon: _freeSolidSvgIcons.faVideo,
      cameraUnavailable: source.cameraUnavailable,
      inactiveIcon: _freeSolidSvgIcons.faVideoSlash,
      enableFeature: enableFeature && canToggleCamera,
      screenReaderText: "Camera Status",
      iconColor: isCameraOn ? '#33373d' : '#de2f1b',
      "data-testid": "camera-toggle-".concat(sourceId),
      isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
      onClick: videoClickHandler,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      canToggleCamera: canToggleCamera,
      ddActionName: "Turn Camera Status ".concat(isCameraOn ? 'Off' : 'On', " for ").concat(sourceType, " source - ").concat(sourceId)
    }), isTooltipVisible && _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: "camera-toggle-".concat(sourceId),
      message: isMaximumCameraSourcesOn && !isCameraOn ? _TooltipMessages.MAX_CAMERA_MESSAGE : toolTipMessage
    }), displayPermissionTooltip(enableFeature, targetElementId, canToggleCamera));
  };
  var SoloIcon = function SoloIcon() {
    var targetElementId = "solo-toggle-".concat(sourceId);
    var iconShouldBeActive = live && layout === _.SINGLE.id;
    return _react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, _react["default"].createElement(_SourceListItemCtaIcons.StyledSoloIcon, {
      $isStagedSourcesActive: isStagedSourcesActive,
      screenReaderText: "Solo",
      active: iconShouldBeActive,
      onClick: onSourceSetToLive,
      activeIcon: _freeSolidSvgIcons.faMaximize,
      inactiveIcon: _freeSolidSvgIcons.faMaximize,
      enableFeature: true,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      ddActionName: "Solo ".concat(sourceType, " source - ").concat(sourceId)
    }), !isStagedSourcesActive && isTooltipVisible && _react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: translate((0, _TooltipMessages.getSoloMessage)())
    }));
  };
  var presenterIcons = _react["default"].createElement(_SourceListItemCtaIcons.IconContainer, {
    $isHovered: hovered
  }, hovered && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayFeaturedIcon.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  }), _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayVideoToggleComponent.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  })), _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayMuteComponent.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  }));
  var mediaIcons = _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayVideoMediaControls.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  });
  var isSoloIconVisible = hovered && sourceType !== _.AUDIO_FILE;
  return _react["default"].createElement(_SourceListItemCtaIcons.StyledSection, null, _react["default"].createElement("div", null, isSoloIconVisible && _react["default"].createElement(SoloIcon, {
    onClick: onSourceSetToLive
  })), _react["default"].createElement(PresentationActivePage, {
    source: source
  }), _react["default"].createElement(_react["default"].Fragment, null, sourceType === _.CAMERA_PRESENTER && presenterIcons, [_.VIDEO_FILE, _.AUDIO_FILE].includes(sourceType) && mediaIcons));
};
SourceListItemCtaIcons.propTypes = {
  sourceType: _propTypes["default"].string,
  featured: _propTypes["default"].bool,
  onFeaturedToggleClicked: _propTypes["default"].func,
  muted: _propTypes["default"].bool,
  onMuteToggleClicked: _propTypes["default"].func,
  loop: _propTypes["default"].bool,
  onLoopToggleClicked: _propTypes["default"].func,
  sourceId: _propTypes["default"].string,
  onCameraToggleClicked: _propTypes["default"].func,
  isCameraOn: _propTypes["default"].bool,
  isMaximumCameraSourcesOn: _propTypes["default"].bool,
  onSourceSetToLive: _propTypes["default"].func,
  hovered: _propTypes["default"].bool,
  isStagedSourcesActive: _propTypes["default"].bool,
  isTooltipVisible: _propTypes["default"].bool,
  toggleTooltipVisibilityOn: _propTypes["default"].func,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object,
  source: _propTypes["default"].object
};
var PresentationActivePage = function PresentationActivePage(_ref) {
  var source = _ref.source;
  var type = source.type,
    _source$value$activeP = source.value.activePage,
    activePage = _source$value$activeP === void 0 ? 1 : _source$value$activeP;
  if (type !== _.PDF_FILE) return null;
  return _react["default"].createElement(_SourceListItemCtaIcons.ActivePageContainer, {
    "data-testid": "presentation-active-page"
  }, _react["default"].createElement(_SourceListItemCtaIcons.ActivePage, null, activePage));
};
PresentationActivePage.propTypes = {
  source: _propTypes["default"].shape({
    value: _propTypes["default"].shape({
      activePage: _propTypes["default"].string
    }),
    type: _propTypes["default"].string
  })
};
var _default = exports["default"] = SourceListItemCtaIcons;